// import { DocumentCard } from "./layout/DocummentCard/DocumentCard"
import { DocumentCard } from "components/ui/DocumentCard/DocumentCard"
import { useDocumentDownload } from "hooks/api/downloadFIle/documentDownload.hook"
import { useDocumentPreview } from "hooks/api/downloadFIle/documentPreview.hook"
import { useFileModalStore } from "store/modal.store"
import { Details } from "./layout/Details/Details"
import { useDocuments } from "hooks/api/drawings/drawings.hook"
import { useSearchParams } from "react-router-dom"
import { Skeleton } from "components/ui/skeleton/Skeleton"
import { GeneralFeedback } from "./layout/GeneralFeedback/GeneralFeedback"
import { DocumentModal } from "../DocumentModal/DocumentModal"
import { useCurrentUserStore } from "store/user.store"
import { canActAsOwner } from "helpers/drawingAccess.helper"
import type { TDrawingOwner } from "helpers/drawingAccess.helper"
import type { TDrawingStatus, TFileInfo } from "types/drawer.type"
import style from "./Documents.module.scss"

const { documentsStyles, files, skeleton, generalFeedback } = style

type Props = {
	drawingStatus: TDrawingStatus
	drawingOwner: TDrawingOwner
}

export const Documents = ({ drawingStatus, drawingOwner }: Props) => {
	const { downloadHandle } = useDocumentDownload()
	const { previewLink, previewHandle } = useDocumentPreview()

	const { isFileModalOpen, setFileModalClose } = useFileModalStore()
	const { currentUser } = useCurrentUserStore()

	const [searchParams] = useSearchParams()
	const drawingId = Number(searchParams.get("drawingID"))
	const processingId = Number(searchParams.get("processingID"))

	const { data: documents, isPending: isDocumentsPending } = useDocuments(drawingId, processingId, drawingStatus)
	const allDocuments = documents?.documents

	// General Feedback: the owner, an Admin or a Super Admin (REQ-392; was owner + Super Admin, REQ-79).
	const shouldShowFeedback = canActAsOwner(currentUser?.role, drawingOwner)

	return (
		<>
			<div className={documentsStyles}>
				<Details />
				{isDocumentsPending ? (
					<div className={skeleton}>
						<Skeleton rows={4} />
					</div>
				) : (
					<div className={files}>
						{allDocuments
							? allDocuments.map((item: TFileInfo) => (
									<DocumentCard
										key={item.id}
										file={item}
										downloadFile={(e) => downloadHandle(item.name, item.download_endpoint, item.type, e)}
										openFilePreview={() => previewHandle(item.download_endpoint)}
									/>
								))
							: null}
					</div>
				)}
				<div className={generalFeedback}>
					{/* Show the General Feedback component if the current user is Super Admin or user own file */}
					{shouldShowFeedback ? <GeneralFeedback drawingStatus={drawingStatus} /> : null}
				</div>
			</div>
			<DocumentModal
				isFileModalOpen={isFileModalOpen}
				setFileModalClose={setFileModalClose}
				previewLink={previewLink}
				drawingStatus={drawingStatus}
			/>
		</>
	)
}
